import { render, staticRenderFns } from "./PapasMergeCard.vue?vue&type=template&id=1d782faf&scoped=true&"
import script from "./PapasMergeCard.vue?vue&type=script&lang=js&"
export * from "./PapasMergeCard.vue?vue&type=script&lang=js&"
import style0 from "./PapasMergeCard.vue?vue&type=style&index=0&id=1d782faf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d782faf",
  null
  
)

export default component.exports